/**
 * Shared cart add helpers (Engineering Plastics cart-quote original).
 *
 * Quote: POST /cart/add.js with properties[_ff_quote]=1, then redirect to /cart.
 * Cart:  POST without _ff_quote; open cart drawer/notification when available.
 */
(function (global) {
  'use strict';

  function getCartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function appendCartUiSections(formData) {
    var cartUi = getCartUi();
    if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartUi
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',')
      );
      formData.append('sections_url', window.location.pathname);
    }
    return cartUi;
  }

  function appendProperties(formData, properties) {
    if (!properties) return;
    Object.keys(properties).forEach(function (key) {
      if (properties[key] == null || properties[key] === '') return;
      // Never allow callers to override the quote flag via properties bag for cart adds;
      // quote adds set _ff_quote explicitly in addToQuote.
      if (key === '_ff_quote') return;
      formData.append('properties[' + key + ']', String(properties[key]));
    });
  }

  function resolveCartAddUrl(cartAddUrl) {
    return cartAddUrl || (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  }

  function resolveCartUrl(cartUrl) {
    return cartUrl || (window.routes && window.routes.cart_url) || '/cart';
  }

  async function postAdd(formData, cartAddUrl) {
    var response = await fetch(resolveCartAddUrl(cartAddUrl), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });
    var data = await response.json();
    if (!response.ok || data.status) {
      var err = new Error(data.description || data.message || 'Could not add this item.');
      err.data = data;
      err.response = response;
      throw err;
    }
    return data;
  }

  /**
   * Add a quote line (EP original flow).
   * Always sets properties[_ff_quote]=1 and redirects to /cart unless skipRedirect.
   *
   * @param {{
   *   id: string|number,
   *   quantity?: number,
   *   properties?: Object.<string, string|number>,
   *   cartAddUrl?: string,
   *   cartUrl?: string,
   *   skipRedirect?: boolean
   * }} options
   */
  async function addToQuote(options) {
    options = options || {};
    if (!options.id) throw new Error('Missing variant id');

    var formData = new FormData();
    formData.append('id', String(options.id));
    formData.append('quantity', String(options.quantity || 1));
    formData.append('properties[_ff_quote]', '1');
    appendProperties(formData, options.properties);
    appendCartUiSections(formData);

    var data = await postAdd(formData, options.cartAddUrl);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (!options.skipRedirect) {
      global.location.href = resolveCartUrl(options.cartUrl);
    }
    return data;
  }

  /**
   * Plain add to cart — never sets _ff_quote.
   *
   * @param {{
   *   id: string|number,
   *   quantity?: number,
   *   properties?: Object.<string, string|number>,
   *   cartAddUrl?: string,
   *   cartUrl?: string,
   *   redirect?: boolean,
   *   openCartUi?: boolean
   * }} options
   */
  async function addToCart(options) {
    options = options || {};
    if (!options.id) throw new Error('Missing variant id');

    var formData = new FormData();
    formData.append('id', String(options.id));
    formData.append('quantity', String(options.quantity || 1));
    appendProperties(formData, options.properties);
    var cartUi = appendCartUiSections(formData);

    var data = await postAdd(formData, options.cartAddUrl);
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    if (options.redirect) {
      global.location.href = resolveCartUrl(options.cartUrl);
      return data;
    }

    var openCartUi = options.openCartUi !== false;
    if (openCartUi && cartUi && typeof cartUi.renderContents === 'function') {
      cartUi.renderContents(data);
    } else {
      global.location.href = resolveCartUrl(options.cartUrl);
    }
    return data;
  }

  global.FFCartAdd = {
    addToQuote: addToQuote,
    addToCart: addToCart,
    postAdd: postAdd,
    appendCartUiSections: appendCartUiSections,
    getCartUi: getCartUi,
  };
})(typeof window !== 'undefined' ? window : this);
